/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventTrackerEventDto } from '../../models/event-tracker-event-dto';

export interface EventTrackerSendEvent$Params {
  'x-trace-id'?: string;
      body: EventTrackerEventDto
}

export function eventTrackerSendEvent(http: HttpClient, rootUrl: string, params: EventTrackerSendEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, eventTrackerSendEvent.PATH, 'post');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

eventTrackerSendEvent.PATH = '/api/event-tracker/events';
